module.exports = __webpack_public_path__ + "23bc43503c00099a1627837899ff9206.svg";